import { CategoryDictionaryHelper } from '../../helper'

describe('CategoryDictionaryHelper', () => {
  const { categoryName } = CategoryDictionaryHelper

  describe('#titalizeWord', () => {
    [
      'questions_basic_info',
      'questions_experience',
      'questions_legal',
      'questions_demographics',
      'questions_closing',
      'questions_story',
      'questions_payroll_info',
      'questions_payroll_revenue'
    ].forEach(category => {
      it('should return string', () => {
        const string = categoryName(category)

        expect(typeof string).toBe("string")
      })
    })
  })
})
